export default "__VITE_ASSET__BwbcS7OS__"